import MoreOptions from '../src/MoreOptions';
export default MoreOptions;
